<ng-container *ngIf="testConfig$ | async as testConfig">
  <section *ngIf="editStatuses"
           class="treatment-view-wrapper"
           [ngClass]="{
              'treatment-view-wrapper-vertical': testConfig.testViewVerticalLayout,
              'treatment-view-high': testConfig.testViewHorizontalHigh,
              'pathway-test': !!testConfig.isPathwayTest
          }"
  >
    <ng-container *ngIf="viewConfig$ | async as viewConfig">
      <section class="left-panel"
               [ngStyle]="viewConfig.subject_selection_section.width ? {'flex-basis': viewConfig.subject_selection_section.width}: { }"
      >
        <span class="section-title subject-section-title" *ngIf="viewConfig.subject_selection_section.title">
          {{viewConfig.subject_selection_section.title}}
        </span>

        <gen-dynamic-form class="navigation_panel"
                          *ngIf=" !hideNavigationPanel && viewConfig.navigation_path_panel?.formId "
                          [formName]="viewConfig.navigation_path_panel.formId"
        ></gen-dynamic-form>

        <ispm-treatment-subject-wrapper
          [reflexMessage]="reflexMessage$|async"
          [isEditable]="editStatuses.includeEdit"
          [showInReportToggleActive]="editStatuses.showInReportToggleActive"
          [showInMIToggleActive]="editStatuses.showInMIToggleActive"
          [subjectsListConfiguration]="viewConfig.subject_selection_section"
          (onSubjectChange)="onSubjectChange($event)"
          (onchangeOpinionOfMI)="changeOpinionOfMI($event)"
          (onDataReceived)="onDataReceived($event)"
        ></ispm-treatment-subject-wrapper>
      </section>

      <section class="middle-panel"
               [ngStyle]="viewConfig.information_section.width ? {'flex-basis': viewConfig.information_section.width} : { }"
      >
        <gen-treatment-information-wrapper
          [layout]="testConfig.testViewVerticalLayout"
          [isEditable]="editStatuses.edit"
          [section]="viewConfig.information_section"
          [subjectIdentifier$]="subjectIdentifier$"
          [dataFromLeftPanel$]="dataFromLeftPanel$"
        ></gen-treatment-information-wrapper>
      </section>

      <section class="right-panel"
               [ngClass]="viewConfig.summary_section.cssClass"
               [ngStyle]="viewConfig.summary_section.width ? {'flex-basis': viewConfig.summary_section.width} : { }"
      >
        <span class="section-title summary-section-title">{{viewConfig.summary_section.title | stringTranslate}}</span>
        <ispm-treatment-summary
          [editStatuses]="editStatuses"
          [summarySectionConfiguration]="viewConfig.summary_section"
          [isPerformer]="isPerformer"
          [changeOpinionOfMIIn]="changeOpinionOfMIIn">
        </ispm-treatment-summary>
      </section>
    </ng-container>
  </section>
</ng-container>

<gen-overlay-loader
  *ngIf="isSpinnerActive$|async"
  class="loader-wrapper">
</gen-overlay-loader>

<gen-dynamic-modal-loader
  class="treatment-modal"
  [observableName]="ModalLoaderTunnelName">
</gen-dynamic-modal-loader>
